import React from 'react'
import swal from "sweetalert";
import SnowDownloadModal from './SnowDownloadModal'

import { DateInput } from "semantic-ui-calendar-react";
import moment from 'moment'
import { Icon, Menu, Popup, Message, Button } from "semantic-ui-react";
import { MDBBtn } from 'mdbreact'
import colors from '../colors'
import { Segment, Sidebar } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { DateRange } from 'react-date-range';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import calendar from "./calendar.ico";
export default class SnowTable extends React.Component {
  constructor(props) {
    super(props)
    console.log(props.date)
    this.state = {
      modal: false,
      date: null,
      activeIndex: 0,
      // selectionRange:
      // {

      //     startDate: new Date(props.etstart_date),
      //     endDate: new Date(props.etend_date),
      //   key: 'selection'

      // },

    }
  }



  handleDownload = async () => {
    this.props.handleSubmitDisable()
    this.setState({
      modal: true
    })
    
      //   try {
      //     cas.redirect();
      //     let result=await cas.getLogin()
      //     console.log(result)
      //   } catch (err) {
      //     if (err.error !== "login_required") console.log("error: " + err);
      //   }
      // }
    
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }
  render() 
  {
    let snowproducts,enabledDates_snow1;

    const enabledDates_snow = this.props.snowdates.map((momentDate) => momentDate.toDate());
    if (this.props.snowavailableDates!==null){
       enabledDates_snow1=this.props.snowavailableDates.map((momentDate) => momentDate.toDate());
    }


    if (this.props.snowproducts !== null) {
      snowproducts = this.props.snowproducts.map((product) => {
        return (<option value={product}>{product}</option>)
      })

    }


    return (
      <div>
        {this.state.modal ? <SnowDownloadModal modal={this.state.modal} title="Spatial Snowmelt Rate" toggle={this.toggle} d1={this.props.d1} d2={this.props.d2} theme="SNOW"
          product={this.props.snowselectedproduct}
          snowdate={moment(this.props.snowdate, "DD-MM-YYYY").format("YYYYMMDD")}
          user={window.sessionStorage.getItem("loginUser")} /> : null}


        <div className="wrapper_data">
          <div id="one">

            Select Product
                    <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleSnowProductChange}
              value={this.props.snowselectedproduct}
              selected={this.props.snowproduct}
            >
              <option value="#">Select</option>
              {snowproducts}

            </select>
          </div>
          <div id="two">
            Availability {this.props.snowstart_date !== null && this.props.snowend_date !== null ?
              <p style={{ color: "blue" }}> {moment(this.props.snowstart_date, "DD-MM-YYYY").format("DD-MMM-YYYY")} - {moment(this.props.snowend_date, "DD-MM-YYYY").format("DD-MMM-YYYY")} </p> : null}

          </div>
        </div>


        {this.props.selectionRange !== null && this.props.snowend_date !== null && this.props.snowselectedproduct === 'Daily Snow Cover Area' ?
          <div className="wrapper_data">

            <div id="one">


              Date Range Selection
                <br />   <DateRange

                ranges={[this.props.selectionRange]}
                onChange={this.props.handleSelect}
                moveRangeOnFirstSelection={false}
                minDate={new Date(this.props.snowstart_date)}
                maxDate={new Date(this.props.snowend_date)}

                dayContentRenderer={(date) => {
                  const enabledDates_snow = this.props.snowdates.map((momentDate) => momentDate.toDate());
              
                  const isAvailable = enabledDates_snow.some(
                    (enabledDate) =>
                      enabledDate.toISOString().split("T")[0] === date.toISOString().split("T")[0]
                  );
                  return (
                    <div
                      style={{
                        backgroundColor: isAvailable ? "#90EE90" : "transparent", // Light green for available dates
                         borderRadius: "50%",
                         color:"black",
                        // paddingTop: "10px",
                        // paddingLeft:"10px",
                        // paddingRight:"10px",
                        // paddingBottom:"-10px",
                        padding:"10px",


                        textAlign:"center",
                      }}
                    >
                      {date.getDate()}
                    </div>
                  );
                }}
              /> <br />

            </div>
            <div id="two">
              {this.props.date1 !== null ? <Message size='small'>Selected Dates:&nbsp;{
                moment(this.props.date1, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY")} - {moment(this.props.date2, "DD-MM-YYYY").format(
                    "DD-MMM-YYYY")}</Message> : null}

              {!this.props.submitdisable ?
                <button
                  onClick={this.handleDownload}
                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button> : null}

              <Message warning>* Maximum downloadable dates at a time is 10 </Message>


            </div>
          </div>
          :
          <div className="wrapper_data">
            <div id="one">
              {this.props.snowavailableDates !== null && this.props.snowend_date !== null && this.props.snowdate !== null ?

                // <DateInput
                //   // inline
                //   name="snowdate"
                //   inline
                //   value={moment(this.props.snowdate, "DD-MM-YYYY").format(
                //     "DD-MM-YYYY"
                //   )}
                //   onChange={this.props.handleSnowDateChange}
                //   dateFormat="DD-MM-YYYY"
                //   markColor="orange"
                //   placeholder="Date"
                //   iconPosition="left"
                //   closable={false}
                //   initialDate={this.props.snowdate}
                //   maxDate={this.props.snowend_date}
                //   minDate={this.props.snowstart_date}

                //   // value={this.state.date}
                //   closeOnMouseLeave
                //   enable={this.props.snowavailableDates}
                //   marked={this.props.snowavailableDates}
                //   startMode="day"
                //   pickerWidth="200px"
                //   popupPosition="top right"
                //   clearIcon={<Icon name="remove" color="red" />}
                // /> 
                // 
                
                <DatePicker
                closeOnScroll={true}

                  // inline
                  name="date"
                 inline={true}
                 
                value={moment(this.props.snowdate, "DD-MM-YYYY").format(
                  "DD-MM-YYYY"
                  )}
                  //onChange={this.props.handleSnowDateChange}

                  onChange={(date) => this.props.handleSnowDateChange(null, { name: 'snowdate', value: moment(date).format('DD-MM-YYYY') })}
                  dateFormat="DD-MM-YYYY"
                  highlightDatesStyles="orange"
                  placeholder="Date"
                  iconPosition="left"
                  highlightDates={enabledDates_snow1.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                  filterDate={(date) => enabledDates_snow1.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                  dayClassName={(date) => {
                    const isEnabled = enabledDates_snow1.some(
                      (enabledDate) => enabledDate.toDateString() === date.toDateString()
                    );
                    return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                  }}
                  showMonthDropdown
                  showYearDropdown
                  scrollableYearDropdown
                  closable
                  //initialDate={this.props.date}
                  ///enable={this.props.availableDates}
                  //marked={this.props.availableDates}
                 //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                  //includeDates={this.props.availableDates.map((date) =>
                 //   moment(date, "DD-MM-YYYY").toDate()
                 // )}
                  startMode="day"
                  pickerWidth="200px"
                 
                  popupPosition="top right"
                  clearIcon={<Icon name="remove" color="red" />}
                  minDate={new Date(Math.min(...enabledDates_snow1.map((d) => d.getTime())))} // Set the minimum date
                  maxDate={new Date(Math.max(...enabledDates_snow1.map((d) => d.getTime())))} // Set the maximum date
               
                /> 
                
                : null}

            </div>
            <div id="two">
              {this.props.snowdate !== null && this.props.download_enable ? <Message size='small'>Selected Date:&nbsp;{
                moment(this.props.snowdate, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY")}</Message> : null}
              {!this.props.submitdisable ?
                <button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
                : null}




            </div>


          </div>}

        {/* <Button animated>
                    <Link to="/webgis-snow/map">   <Button.Content visible>Geoportal</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Link>
                </Button> */}


      </div>






    )
  }
}


